// =============================================================================
// MESSAGEFORMAT.JS — Turning Ace's replies into something safe to render.
// =============================================================================
// Ace's panel used to build an HTML string (**bold** -> <strong>, \n -> <br/>)
// and hand it to dangerouslySetInnerHTML. That makes every message a script
// injection waiting to happen: the model's output is not trusted input, and
// neither is the user's own text, which is echoed back into the same bubble.
// A reply containing <img src=x onerror=...> would simply run.
//
// So this file does not produce HTML. It produces DATA — a list of lines, each
// a list of text runs — and the component renders those as React elements.
// React escapes text nodes, so there is no markup path at all. The formatting
// that was actually wanted (bold, line breaks) survives; the injection does not.
// =============================================================================

/**
 * Parse the small subset of Markdown Ace actually emits.
 *
 * Returns lines[] of runs[], where each run is { text, bold }. Empty lines come
 * back as an empty array so the renderer can still emit the line break.
 */
export function parseMessage(text) {
  const source = typeof text === 'string' ? text : ''
  if (!source) return []

  return source.split('\n').map(line => {
    // Built per call: a /g regex kept at module scope carries lastIndex between
    // calls and would silently skip matches on the following line.
    const bold = /\*\*([\s\S]+?)\*\*/g
    const runs = []
    let cursor = 0
    let match

    while ((match = bold.exec(line)) !== null) {
      if (match.index > cursor) {
        runs.push({ text: line.slice(cursor, match.index), bold: false })
      }
      runs.push({ text: match[1], bold: true })
      cursor = match.index + match[0].length
    }

    if (cursor < line.length) {
      runs.push({ text: line.slice(cursor), bold: false })
    }

    return runs
  })
}
